function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1)",
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M75.812 12H86a5 5 0 015 5v117a5 5 0 01-5 5H5a5 5 0 01-5-5V17a5 5 0 015-5h10.471",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 7,
  r: 1.5
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M17 42.15L22.134 47 30 37M17 64.15L22.134 69 30 59M17 86.15L22.134 91 30 81M17 108.15l5.134 4.85L30 103M34.297 43.5h38.338M34.297 65.5h38.338M34.297 87.5h38.338M34.297 109.5h38.338"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.808 17H85v115H6V17h9.651"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5 9v.5H17a1.5 1.5 0 00-1.5 1.5v7a1.5 1.5 0 001.5 1.5h57a1.5 1.5 0 001.5-1.5v-7A1.5 1.5 0 0074 9.5H54.5V9a8.5 8.5 0 10-17 0z"
}));

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 140,
    viewBox: "0 0 93 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.c2b37f98.svg";
export { ForwardRef as ReactComponent };